import React from "react";
import { Typography, Link } from "@material-ui/core";
import PrimaryButton from '../library/buttons/primary-button';
import { COLORS } from "../../styles/constants/colors";
import { FONTS } from "../../styles/constants/fonts";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
  root: {
    marginTop: '60px',
    textAlign: 'center',
    '@media print': {
      display: 'none',
    }
  },
  callAction: {
    padding: '60px 0',
    backgroundColor: COLORS.WHITE,
  },
  info: {
    color: COLORS.DARKGREY,
  },
  copyright: {
    padding: '32px 0',
    fontFamily: `${FONTS.SECONDARY}, ${FONTS.DEFAULT}`,
    fontSize: '18px',
    lineHeight: '28px',
    color: COLORS.DARKGREY,
    '& a': {
      color: COLORS.PRIMARY,
    }
  }
}));

export default function Footer() {
  const classes = useStyles();

  return (
    <footer className={classes.root}>
      <div className={classes.callAction}>
        <Typography variant="h2">Ready to start saving?</Typography>
        <Typography variant="h4" className={classes.info}>Click to schedule a meeting with someone on our team.</Typography>
        <PrimaryButton marginTop="32px" href="https://comesave.livable.com/meetings/livable/livable-discovery-call" target="_blank">Schedule a call</PrimaryButton>
      </div>
      <div className={classes.copyright}>
        Copyright © Livable, Inc. All Rights Reserved.&nbsp;
        <Link href="https://www.livable.com/privacy/" target="_blank">Privacy Policy</Link>
      </div>
    </footer>
  );
}
